export default function BrandMark({compact=false}:{compact?:boolean}){
 return <span className={compact?"mil-brand compact":"mil-brand"} aria-label="MIL IAgentes">
  <svg viewBox="0 0 64 64" aria-hidden="true">
   <defs>
    <linearGradient id="milSignalGradient" x1="14" y1="18" x2="52" y2="48" gradientUnits="userSpaceOnUse">
     <stop stopColor="#D8FF68"/><stop offset=".52" stopColor="#8FE8C9"/><stop offset="1" stopColor="#72D8FF"/>
    </linearGradient>
   </defs>
   <rect width="64" height="64" rx="18"/>
   <path d="M14 44V21.5c0-2.4 2.9-3.6 4.6-1.9L32 33l13.4-13.4c1.7-1.7 4.6-.5 4.6 1.9V44" stroke="url(#milSignalGradient)"/>
   <circle cx="32" cy="47" r="3.25" fill="#D8FF68"/>
  </svg>
  {!compact&&<span><b>MIL</b> IAgentes</span>}
 </span>;
}
